<template>
  <div>
    <Header></Header>
    <div class="background">
      <div class="details" v-for="(list,index) in lists" :key="index">
        <!-- 微导航 -->
        <div class="wnav">
          <span>测评体系</span> >
          <span>更多测评</span> >
          <span class="gengduo">测评详情</span>
        </div>
        <!-- 头部 -->
        <div class="title">
          <div class="img">
            <img :src="list.image" alt />
          </div>
          <div class="right">
            <p class="bt">{{list.name}}</p>
            <p class="jg" v-if="list.members_free==1">¥{{list.price}}</p>
            <p class="jg" v-if="list.price!=0.00&&list.members_free==0">¥{{list.price}}</p>
            <p class="jg" v-if="list.price==0.00&&list.members_free!=1">免费</p>
            <div class="gm">
              <p class="btn" @click="gopay(list)">开始评测</p>
              <div @click="shareToQQ" class="tb">
                <img src="../../assets/img/fx.png" alt />
              </div>
            </div>
          </div>
        </div>
        <!-- 身体 -->
        <div class="st">
          <div class="left">
            <ul>
              <li class="active">测评介绍</li>
            </ul>
            <!-- <div>测评概述：</div> -->
            <div>{{list.intro}}</div>
            <div>
               <img style="width:760px; margin:0 auto;" :src="list.content_image" alt />
            </div>
           
          </div>
          <div class="right">
            <div class="xgpc">
              <div class="title1">相关评测</div>
              <div
                class="cont"
                @click="goevdetails(xgpc)"
                v-for="(xgpc,index) in list.appraisal_array"
                :key="index"
              >
                <img :src="xgpc.image" alt />
                <div class="cont-right">
                  <div class="cont-name">{{xgpc.name}}</div>
                  <p class="cont-price" v-if="xgpc.members_free==1">VIP</p>
                  <p
                    class="cont-price"
                    v-if="xgpc.price!=0.00&&xgpc.members_free==0"
                  >¥{{xgpc.price}}</p>
                  <p class="cont-price" v-if="xgpc.price==0.00">免费</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 绑定验证手机号 -->
    <div>
      <div class="login" v-show="popup==2">
        <img src="../../assets/img/dlbg.png" alt />
        <div class="right">
          <img class="close" src="../../assets/img/xx.png" alt @click="closepopup" />
          <div class="phone">绑定手机号</div>
          <input type="text" class="int" v-model="phone1" placeholder="请输入手机号" />
          <div class="Password">验证码</div>
          <div class="yzm">
            <input type="text" class="yzm-i" v-model="code2" placeholder="请输入验证码" />
            <div class="yzm-btn" v-show="show" @click="getyzm">获取验证码</div>
            <div class="yzm-btn djs" v-show="!show">{{count}}s后获取</div>
          </div>
          <div class="phone">密码</div>
          <input type="password" class="int" v-model="password" placeholder="请输入密码" />
          <div class="Password">邀请码（选填）</div>
          <input type="text" v-model="invitation" class="int" placeholder="请输入邀请码" />
          <div class="btn" @click="bangding_phone()">立即绑定</div>
        </div>
      </div>
    </div>
    <!--这里是半透明背景层-->
    <div class="over" v-show="popup!=1"></div>
    <Footer></Footer>
    <Login v-show="popup==3"></Login>
  </div>
</template>

<script>
import Header from "../header";
import Footer from "../footer";
import Login from "../popup/login";
export default {
    // 无感刷新引入
  inject: ["reload"],
  name: "details",
  data() {
    return {
      id: "",
      lists: [],
      popup: "1",
      phone1: "", //手机号
      code2: "", //验证码
      password: "", //密码
      invitation: "", //邀请码
      show: true,
      count: "0", //倒计时
      timer: null,
      code1: "",
    };
  },
  created() {
    this.id = this.$route.query.id;
    if (JSON.parse(sessionStorage.getItem("data"))) {
      this.uid = JSON.parse(sessionStorage.getItem("data")).id;
    }
  },
  methods: {
    // 测评
    async appraisal_detail() {
      // var id = JSON.parse(sessionStorage.getItem("data"));
      await this.$service.home
        .appraisal_detail({ id: this.id, pc: 1 })
        .then((res) => {
          // console.log(res.data.content);
          if (res.data.code == 200) {
            var arr = [];
            arr.push(res.data.content);
            this.lists = arr;
            this.collection1 = res.data.content.collection;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //分享到QQ好友(PC端可用)
    shareToQQ() {
      //此处分享链接内无法携带图片
      const share = {
        title: "知会教育",
        desc: "知会教育pc端QQ分享",
        share_url: window.location.href,
      };
      location.replace(
        "https://connect.qq.com/widget/shareqq/index.html?url=" +
          encodeURIComponent(share.share_url) +
          "&title=" +
          share.title +
          "&desc=" +
          share.desc
      );
    },
    // 开始评测
    async gopay(list) {
      if (JSON.parse(sessionStorage.getItem("data"))) {
        var if_phone = sessionStorage.getItem("if_phone");
        if (if_phone == 1) {
          await this.$service.home
            .pay_appraisal({ id: this.id, uid: this.uid })
            .then((res) => {
              // console.log(res.data.content);
              if (res.data.code == 200) {
                if (res.data.content.appraisalmy_id) {
                  this.$router.push({
                    path: "/evalu_ceping",
                    query: {
                      id: res.data.content.appraisalmy_id,
                      name: list.name,
                    },
                  });
                }
                if (res.data.content.order_id) {
                  var money = res.data.content.money;
                  var order_id = res.data.content.order_id;
                  this.$router.push({
                    path: "/cp_pay",
                    query: {
                      id: list.id,
                      money: money,
                      order_id: order_id,
                    },
                  });
                }
              }
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          this.popup = 2;
        }
      } else {
        this.popup = 3;
      }
    },
    // 验证码获取
    async getyzm() {
      if (
        !/^((1[3,5,8][0-9])|(14[5,7])|(17[0,6,7,8,5])|(19[7]))\d{8}$/.test(
          this.phone1
        )
      ) {
        this.$confirm("手机号格式错误")
          .then((_) => {
            done();
          })
          .catch((_) => {});
        return false;
      } else {
        const TIME_COUNT = 60;
        var phone1 = this.phone1;
        if (!this.timer) {
          this.count = TIME_COUNT;
          this.show = false;
          this.timer = setInterval(() => {
            if (this.count > 0 && this.count <= TIME_COUNT) {
              this.count--;
            } else {
              this.show = true;
              clearInterval(this.timer);
              this.timer = null;
            }
          }, 1000);
        }
        await this.$service.home
          .getyzm({
            phone: phone1,
            type: 1,
          })
          .then((res) => {
            console.log(res);
            if (res.data) {
              if (res.data.code == 200) {
                this.code1 = res.data.content;
              }
            }
            if (res.err) {
              if (res.err.data.code == 201) {
                this.$confirm(res.err.data.msg)
                  .then((_) => {
                    done();
                  })
                  .catch((_) => {});
              }
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    // 验证手机号
    async bangding_phone() {
      var phone2 = this.phone1;
      var code = this.code2;
      var password = this.password;
      if (phone2 && code && password) {
        await this.$service.home
          .ifcode({
            phone: phone2,
            code: code,
          })
          .then((res) => {
            console.log(res);
            if (res.data) {
              if (res.data.code == 200) {
                this.bangding();
              }
            }
            if (res.err) {
              if (res.err.data.code == 201) {
                this.$confirm(res.err.data.msg)
                  .then((_) => {
                    done();
                  })
                  .catch((_) => {});
              }
            }
          })
          .catch((err) => {});
      } else {
        this.$confirm("必填项不能为空哦")
          .then((_) => {
            done();
          })
          .catch((_) => {});
      }
    },
    // 绑定手机号
    async bangding() {
      var id = JSON.parse(sessionStorage.getItem("data"));
      await this.$service.home
        .bangding_phone({
          uid: id.id,
          phone: this.phone1,
          password: this.password,
          invite_code: this.invitation,
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.$confirm("绑定成功")
              .then((_) => {
                done();
              })
              .catch((_) => {});
              sessionStorage.setItem("if_phone", 1);
            // 页面无感刷新
            this.reload();
          }
        });
    },
        //关闭弹窗
    closepopup() {
      this.popup = 1;
      // 页面无感刷新
      this.reload();
    },
    // 相关评测
    goevdetails(xgpc) {
      this.id = xgpc.id;
      this.appraisal_detail();
    },
  },
  components: {
    Header,
    Footer,
    Login,
  },
  mounted() {
    this.appraisal_detail();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.background .details {
  width: 1200px;
  margin: 0 auto;
}
/* 微导航 */
.background .details .wnav {
  height: 30px;
  line-height: 40px;
  font-size: 14px;
  margin-bottom: 10px;
}
.background .details .wnav span.gengduo {
  color: rgba(136, 136, 136, 1);
}
/* 头部 */
.background .details .title {
  height: 360px;
  background: rgba(255, 255, 255, 1);
  border-radius: 3px;
  border: 1px solid rgba(237, 237, 237, 1);
  display: flex;
  justify-content: space-around;
}
.background .details .title .img img {
  width: 480px;
  height: 320px;
  margin-top: 25px;
}
.background .details .title .right .bt {
  width: 655px;
  height: 60px;
  font-size: 26px;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 40px;
}
.background .details .title .right .jg {
  width: 655px;
  font-size: 36px;
  font-weight: bold;
  color: rgba(255, 83, 91, 1);
  margin: 0;
}
.background .details .title .right .gm {
  display: flex;
  justify-content: space-between;
  margin-top: 120px;
}
.background .details .title .right .gm .btn {
  width: 154px;
  height: 44px;
  background: rgba(23, 117, 239, 1);
  border-radius: 22px;
  font-size: 20px;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  line-height: 44px;
  text-align: center;
}
.background .details .title .right .gm .tb {
  padding-top: 22px;
}
.background .details .st {
  margin-top: 16px;
  display: flex;
  justify-content: space-between;
  position: relative;
}
.background .details .st .left {
  width: 860px;
  background: rgba(255, 255, 255, 1);
  border-radius: 3px;
}
.background .details .st .left div {
  font-size: 14px;
  font-family: PingFang-SC-Medium, PingFang-SC;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  margin: 0 0 16px 40px;
}
.background .details .st .left ul {
  display: flex;
  border-bottom: 1px solid #ededed;
}
.background .details .st .left ul li {
  height: 62px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
}
.background .details .st .left ul li.active {
  color: #1775ef;
}
.background .details .st .right {
  width: 324px;
  height: 687px;
  background: rgba(255, 255, 255, 1);
  border-radius: 3px;
  border: 1px solid rgba(237, 237, 237, 1);
}
.background .details .st .right .xgpc {
  width: 290px;
  margin: 0 auto;
  margin-top: 20px;
}
.background .details .st .right .xgpc .title1 {
  font-size: 16px;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  line-height: 22px;
  margin-bottom: 21px;
}
.background .details .st .right .xgpc .cont {
  margin-bottom: 22px;
  display: flex;
}
.background .details .st .right .xgpc .cont img {
  width: 120px;
  height: 67px;
  margin-right: 6px;
}
.background .details .st .right .xgpc .cont .cont-name {
  font-size: 14px;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 20px;
}
.background .details .st .right .xgpc .cont .cont-price {
  font-size: 12px;
  font-weight: 500;
  color: rgba(255, 67, 67, 1);
  line-height: 18px;
  margin: 9px 0 0 135px;
}
/* 绑定手机号 */
.over {
  position: fixed;
  width: 100%;
  height: 100%;
  opacity: 0.5;
  filter: alpha(opacity=50);
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #111111;
}
.login {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
  width: 700px;
  height: 420px;
  background: rgba(255, 255, 255, 1);
  display: flex;
}
.login .right {
  margin-left: 62px;
  margin-top: 16px;
}
.login .right .bot {
  display: flex;
  margin-top: 12px;
}
.login .right .bot .fanhui {
  font-size: 12px;
  font-weight: 500;
  color: rgba(102, 102, 102, 1);
  margin-left: 1px;
}
.login .right .bot img {
  margin-top: 100px;
}
.login .right .bot .fanhui1 {
  font-size: 12px;
  font-weight: 500;
  color: rgba(102, 102, 102, 1);
  margin-top: 100px;
}
.login .right .bot .bot-r {
  display: flex;
  font-size: 12px;
  font-weight: 500;
  margin-left: 62px;
}
.login .right .bot .ty {
  color: rgba(136, 136, 136, 1);
}
.login .right .bot .xieyi {
  color: #1775ef;
}
.login .right .close {
  margin-left: 306px;
}
.login .right .title {
  font-size: 24px;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  margin-bottom: 22px;
}
.login .right .title1 {
  font-size: 24px;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  text-align: center;
  margin-bottom: 22px;
}
.login .right .phone,
.login .right .Password {
  font-size: 14px;
  font-weight: 500;
  color: rgba(136, 136, 136, 1);
  margin-bottom: 6px;
}
.login .right .btn {
  width: 280px;
  height: 46px;
  background: rgba(23, 117, 239, 1);
  border-radius: 6px;
  text-align: center;
  line-height: 46px;
  color: #ffffff;
  margin-bottom: 10px;
}
.login .right .register1 {
  font-size: 12px;
  font-weight: 500;
  color: rgba(23, 117, 239, 1);
  margin-left: 172px;
}
input::-webkit-input-placeholder {
  padding-left: 10px;
}
.login .right input.int {
  background-color: #f8f8f8;
  width: 280px;
  height: 36px;
  border-radius: 6px;
  border: none;
  margin-bottom: 16px;
}
.login .right .yzm {
  display: flex;
  margin-bottom: 16px;
}
.login .right input.yzm-i {
  width: 168px;
  height: 36px;
  margin-right: 12px;
  background-color: #f8f8f8;
  border-radius: 6px;
  border: none;
}
.login .right .yzm-btn {
  width: 100px;
  height: 36px;
  background: rgba(23, 117, 239, 1);
  border-radius: 6px;
  color: #ffffff;
  font-size: 14px;
  line-height: 36px;
  text-align: center;
}
.login .right .djs {
  background-color: #ccc;
}
</style>



// WEBPACK FOOTER //
// src/components/cptx/evalu_details.vue